import { all, call, put, takeLeading } from 'redux-saga/effects';
import {
	getTemplateDetailFailed, getTemplateDetailSuccess, getTemplatesFailed, getTemplatesSuccess,
	GET_TEMPLATES, GET_TEMPLATE_DETAIL, SAVE_TEMPLATE, saveTemplateSuccess, saveTemplateFailed,
	DOWNLOAD_TEMPLATE, downloadTemplateSuccess, downloadTemplateFailed,
	APPROVE_TEMPLATE, approveTemplateSuccess, approveTemplateFailed,
	DENY_TEMPLATE, denyTemplateSuccess, denyTemplateFailed,
	DELETE_TEMPLATE, deleteTemplateSuccess, deleteTemplateFailed
} from './template.actions';
import {
	getTemplateDetailAsync, getTemplatesAsync, saveTemplate, downloadTemplate,
	approveTemplate, denyTemplate,
	deleteTemplate
} from './template.api';
import { IAction, ISaveTemplateResponse, IApproveTemplateResponse, IDeleteTemplateResponse } from '../../types/types';
import { AlertType } from '../../types/enums';
import { showAlert } from '../Alerts/alerts.actions';


function* getTemplatesSaga({ payload: { filter } }: any): any {
	try {
		let data = yield call(getTemplatesAsync, filter);
		yield put(getTemplatesSuccess(data));
	} catch (error: any) {
		yield put(getTemplatesFailed(error.message));
	}
}

function* getTemplatesWatcher() {
	yield takeLeading(GET_TEMPLATES, getTemplatesSaga)
}

function* getTemplateDetailSaga({ payload: { templateId } }: any): any {
	try {

		let data = yield call(getTemplateDetailAsync, templateId);
		yield put(getTemplateDetailSuccess(data));
	} catch (error: any) {
		yield put(getTemplateDetailFailed(error.message));
	}
}

function* getTemplateDetailWatcher() {
	yield takeLeading(GET_TEMPLATE_DETAIL, getTemplateDetailSaga)
}

function* saveTemplateSaga(action: IAction): any {
	try {
		let { result, ...data } = yield call(saveTemplate, action.payload);
		if (result) {
			const saveTemplateResponse: ISaveTemplateResponse = { success: true, message: 'template updated successfully.' }
			yield put(saveTemplateSuccess(saveTemplateResponse));
		} else
			yield put(saveTemplateFailed(data.message));
		yield put(showAlert({
			hidden: false,
			...data
		}));
	} catch (error: any) {
		yield put(saveTemplateFailed(error.message));
	}
}

function* saveTemplateWatcher() {
	yield takeLeading(SAVE_TEMPLATE, saveTemplateSaga)
}


function* downloadTemplateSaga(action: any): any {
	try {
		yield call(downloadTemplate, action.templateId);
		yield put(downloadTemplateSuccess());

	} catch (error: any) {
		yield put(downloadTemplateFailed(error.message));
		yield put(showAlert({
			hidden: false,
			message: "There was an error downloading the template.",
			severity: AlertType.error
		}));
	}
}

function* downloadTemplateWatcher() {
	yield takeLeading(DOWNLOAD_TEMPLATE, downloadTemplateSaga)
}

function* approveTemplateSaga(action: IAction): any {
	try {
		yield call(approveTemplate, action.payload);
		const approveTemplateResponse: IApproveTemplateResponse = {
			success: true, message: 'template approved successfully.'
		}
		yield put(approveTemplateSuccess(approveTemplateResponse));
		yield put(showAlert({
			hidden: false,
			message: approveTemplateResponse.message,
			severity: approveTemplateResponse.success
				? AlertType.success
				: AlertType.error
		}));
	} catch (error: any) {
		yield put(approveTemplateFailed(error.message));
	}
}

function* approveTemplateWatcher() {
	yield takeLeading(APPROVE_TEMPLATE, approveTemplateSaga)
}

function* denyTemplateSaga(action: IAction): any {
	try {
		yield call(denyTemplate, action.payload);
		const denyTemplateResponse: IApproveTemplateResponse = {
			success: true, message: 'template successfully unapproved.'
		}
		yield put(denyTemplateSuccess(denyTemplateResponse));
		yield put(showAlert({
			hidden: false,
			message: denyTemplateResponse.message,
			severity: denyTemplateResponse.success
				? AlertType.success
				: AlertType.error
		}));
	} catch (error: any) {
		yield put(denyTemplateFailed(error.message));
	}
}

function* denyTemplateWatcher() {
	yield takeLeading(DENY_TEMPLATE, denyTemplateSaga)
}

function* deleteTemplateSaga(action: any): any {
	try {
		yield call(deleteTemplate, action.id);
		const deleteTemplateResponse: IDeleteTemplateResponse = {
			success: true, message: 'template successfully deleted.'
		}
		yield put(deleteTemplateSuccess(deleteTemplateResponse));
		yield put(showAlert({
			hidden: false,
			message: deleteTemplateResponse.message,
			severity: deleteTemplateResponse.success
				? AlertType.success
				: AlertType.error
		}));
	} catch (error: any) {
		yield put(deleteTemplateFailed(error.message));
	}
}

function* deleteTemplateWatcher() {
	yield takeLeading(DELETE_TEMPLATE, deleteTemplateSaga)
}

export default function* templateSaga() {
	yield all([getTemplatesWatcher(),
	getTemplateDetailWatcher(),
	saveTemplateWatcher(),
	downloadTemplateWatcher(),
	approveTemplateWatcher(),
	denyTemplateWatcher(),
	deleteTemplateWatcher()
	]);
}